import { Box, makeStyles } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "../../configurations/themeProvider";
import defaultLogo from "../../images/logo.png";
import "./header.scss";
import UserInformation from "./UserInformation";

const useStyles = makeStyles((theme) => ({
    toolbar: {
        minHeight: "90px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(3),
    },
    leftSection: {
        display: "flex",
        alignItems: "center",
        minWidth: 0,
    },
    rightSection: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        marginLeft: theme.spacing(2),
    },
    defaultLogo: {
        width: 200,
        height: 40,
        objectFit: "contain",
        cursor: "pointer",
    },
    clientLogo: {
        width: 140,
        height: 40,
        objectFit: "contain",
    },
}));

const Header = () => {
    const classes = useStyles();
    const history = useHistory();
    const { clientTheme } = useTheme();
    const [clientLogoError, setClientLogoError] = useState(false);

    useEffect(() => {
        setClientLogoError(false);
    }, [clientTheme.logoUrl]);

    const showClientLogo = Boolean(clientTheme.logoUrl) && !clientLogoError;

    return (
        <AppBar className={"header"} elevation={2} position="static">
            <Toolbar className={classes.toolbar}>
                <Box className={classes.leftSection}>
                    <img
                        src={defaultLogo}
                        className={classes.defaultLogo}
                        onClick={() => history.replace("/home")}
                        alt="Logo Vendemmia"
                    />
                </Box>
                <Box className={classes.rightSection}>
                    {showClientLogo ? (
                        <img
                            src={clientTheme.logoUrl}
                            className={classes.clientLogo}
                            onError={() => setClientLogoError(true)}
                            alt="Logo do cliente"
                        />
                    ) : null}
                    <UserInformation />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;